module.exports = __webpack_public_path__ + "img/sample-medicare-card-part-a.0318f32.png";